export const EXPORT_MAX_PAGE_PIXELS = 24000000;
export const EXPORT_PDF_MAX_PAGE_PIXELS = 90000000;

export const getRasterCompressionScale = (width, height, maxPixels = EXPORT_MAX_PAGE_PIXELS) => {
  const pixelCount = Number(width) * Number(height);
  if (!Number.isFinite(pixelCount) || pixelCount <= 0 || pixelCount <= maxPixels) {
    return 1;
  }
  return Math.sqrt(maxPixels / pixelCount);
};

export const createCompressedTileCanvas = (
  sourceCanvas,
  sx,
  sy,
  sourceWidth,
  sourceHeight,
  { maxPixels = EXPORT_MAX_PAGE_PIXELS } = {}
) => {
  const scale = getRasterCompressionScale(sourceWidth, sourceHeight, maxPixels);
  const targetWidth = Math.max(1, Math.round(sourceWidth * scale));
  const targetHeight = Math.max(1, Math.round(sourceHeight * scale));
  const tile = document.createElement('canvas');
  tile.width = targetWidth;
  tile.height = targetHeight;
  const ctx = tile.getContext('2d');
  if (ctx) {
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(sourceCanvas, sx, sy, sourceWidth, sourceHeight, 0, 0, targetWidth, targetHeight);
  }
  return tile;
};

export const canvasToPngDataUrl = (canvas) => {
  const flattened = document.createElement('canvas');
  flattened.width = canvas.width;
  flattened.height = canvas.height;
  const ctx = flattened.getContext('2d');
  if (ctx) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, flattened.width, flattened.height);
    ctx.drawImage(canvas, 0, 0);
  }
  return flattened.toDataURL('image/png');
};

export const canvasSliceToPngDataUrl = (canvas, sx, sy, width, height) => {
  const slice = document.createElement('canvas');
  slice.width = width;
  slice.height = height;
  const ctx = slice.getContext('2d');
  if (ctx) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(canvas, sx, sy, width, height, 0, 0, width, height);
  }
  return slice.toDataURL('image/png');
};

export const downloadCanvasAsPng = async (canvas, filename) => {
  const blob = await new Promise((resolve) => {
    if (typeof canvas.toBlob !== 'function') {
      resolve(null);
      return;
    }
    canvas.toBlob(resolve, 'image/png');
  });

  if (!blob) {
    const fallback = document.createElement('a');
    fallback.setAttribute('download', filename);
    fallback.setAttribute('href', canvas.toDataURL('image/png'));
    fallback.click();
    return;
  }

  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.setAttribute('download', filename);
    link.setAttribute('href', url);
    link.click();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};
